(function() {
    angular
        .module("app")
        .factory("telemetryService", telemetryService)

    telemetryService.$inject = [
        "$rootScope",
        "$http"
    ]

    function telemetryService(
        $rootScope,
        $http
    ) {
        var service = {}
        var PUBNUB_ACCEPTED_STATUS_CODE = 202

        var getDeviceURL = function(deviceCategory) {
            if (deviceCategory === "Tracker") {
                return "/trackers/"
            }
            return "/message_boards/"
        }


        /**
            Get telemetry data
            @param {string} deviceCategory
            @param {int}    deviceID
            @returns {*}
         **/
        service.getTelemetry = function(deviceCategory, deviceID) {
            var deviceURLLastPath = "/telemetry_message_board"
            if (deviceCategory == "Tracker") {
                deviceURLLastPath = "/telemetry_tracker"
            }
            return $http({
                method: "GET",
                url: $rootScope.config.apiUrl + getDeviceURL(deviceCategory) + deviceID + deviceURLLastPath
            }).then(getTelemetryComplete, getTelemetryFailed)

            function getTelemetryComplete(response) {
                $rootScope.processGPS(response.data)
                return response.data
            }

            function getTelemetryFailed(error) {
                console.error(error)
            }
        }

        service.getRawReport = (trackerID, recordType, recordID, success, failure) => {

            const _success = (response) => {
                if (success) {
                    success(response.data)
                }
            }

            const _failure = (response) => {
                if (failure) {
                    failure(response)
                }
            }

            let url = $rootScope.config.apiUrl + "/trackers/" + trackerID + "/telemetry_trackers/" + recordID + "/raw_report"

            if (recordType === "Alert") {
                url = $rootScope.config.apiUrl + "/trackers/" + trackerID + "/alerts/" + recordID + "/raw_report"
            }

            return $http({
                method: "GET",
                url: url
            }).then(_success, _failure)
        }

        /**
            Refresh device telemetry data
            @param {string} deviceType
            @param {int} deviceID
            @param successCallback
            @param failureCallback
            @returns {*}
         **/
        service.refreshTelemetry = function(deviceType, deviceID, successCallback, failureCallback) {

            let device = "/message_boards/" + deviceID

            if (deviceType === "Arrow Board") {
                device = "/trackers/" + deviceID + "/arrow_board"
            }

            if (deviceType === "Marker") {
                device = "/trackers/" + deviceID + "/marker"
            }

            if (deviceType === "Trucks Enter") {
                device = "/trackers/" + deviceID + "/trucks_enter"
            }

            if (deviceType === "Beacon Trailer") {
                device = "/trackers/" + deviceID + "/beacon_trailer"
            }

            if (deviceType === "Solar Light Tower") {
                device = "/trackers/" + deviceID + "/solar_light_tower"
            }

            if (deviceType === "Speed Trailer") {
                device = "/trackers/" + deviceID + "/speed_trailer"
            }

            if (deviceType.startsWith("QWS Sensor")) {
                device = "/trackers/" + deviceID + "/qws_sensor"
            }

            if (deviceType === "Flagger") {
                device = "/trackers/" + deviceID + "/afad_gate"
            }

            if (deviceType.startsWith("Tracker")) {
                device = "/trackers/" + deviceID
            }

            return $http({
                method: "GET",
                url: $rootScope.config.apiUrl + device + "/retrieve_telemetry"
            }).then(refreshTelemetryComplete, refreshTelemetryFailed)

            function refreshTelemetryComplete(response) {
                successCallback()
                return response.status == PUBNUB_ACCEPTED_STATUS_CODE
            }

            function refreshTelemetryFailed(error) {
                failureCallback(error)
                console.error(error)
            }
        }

        /**
            Refresh message board settings data
            @param {string} deviceType
            @param {int} deviceID
            @param successCallback
            @param failureCallback
            @returns {*}
         **/
        service.refreshSettings = function(deviceType, deviceID, successCallback, failureCallback) {

            let device = "/message_boards/" + deviceID

            if (deviceType === "Arrow Board") {
                device = "/trackers/" + deviceID + "/arrow_board"
            }

            if (deviceType === "Trucks Enter") {
                device = "/trackers/" + deviceID + "/trucks_enter"
            }

            if (deviceType === "Beacon Trailer") {
                device = "/trackers/" + deviceID + "/beacon_trailer"
            }

            if (deviceType.startsWith("QWS Sensor")) {
                device = "/trackers/" + deviceID + "/qws_sensor"
            }

            if (deviceType === "Flagger") {
                device = "/trackers/" + deviceID + "/afad_gate"
            }

            return $http({
                method: "GET",
                url: $rootScope.config.apiUrl + device + "/retrieve_settings"
            }).then(refreshSettingsComplete, refreshSettingsFailed)

            function refreshSettingsComplete(response) {
                successCallback()
                return response.status == PUBNUB_ACCEPTED_STATUS_CODE
            }

            function refreshSettingsFailed(error) {
                failureCallback(error)
                console.error(error)
            }
        }

        /**
            Get battery health
            @param deviceVoltage
            @returns {{text: string, status: string, icon: string}}
         **/
        service.getBatteryHealth = function(deviceVoltage, systemVoltage) {

            let lvd        = 10.7
            let shutdown   = 11.0
            let needCharge = 11.4
            let low        = 12.2

            if (systemVoltage === "24v") {
                lvd        = 21.4
                shutdown   = 22.0
                needCharge = 22.8
                low        = 24.4
            }

            var battery_health = {
                text: "Unknown",
                status: "status-none",
                icon: "fa-battery-empty"
            }

            if (deviceVoltage > 0 && deviceVoltage < lvd) {
                battery_health.text = "LVD (Low Voltage Disconnect)"
                battery_health.status = "status-none"
                battery_health.icon = "fa-battery-empty"
            } else if (deviceVoltage >= lvd && deviceVoltage <= shutdown) {
                battery_health.text = "Shutdown Imminent"
                battery_health.status = "status-red"
                battery_health.icon = "fa-battery-quarter"
            } else if (deviceVoltage > shutdown && deviceVoltage <= needCharge) {
                battery_health.text = "Needs Charging"
                battery_health.status = "status-red"
                battery_health.icon = "fa-battery-quarter"
            } else if (deviceVoltage > needCharge && deviceVoltage <= low) {
                battery_health.text = "Low Battery"
                battery_health.status = "status-orange"
                battery_health.icon = "fa-battery-half"
            } else if (deviceVoltage > low) {
                battery_health.text = "Good"
                battery_health.status = "status-green"
                battery_health.icon = "fa-battery-full"
            }
            return battery_health
        }

        return service
    }
})()
